import React, { Fragment } from "react";
import { themeShadows } from "../appTheme/theme-colors";
import { styled, Box } from "@mui/material";
import {
  Icon,
  Badge,
  Button,
  IconButton,
  Drawer,
} from "@mui/material";
import { sideNavWidth, topBarHeight } from "utils/constant";
import CustomIcon from "assets/icons";
import useNotification from "@/hooks/useNotification";

const Notification = styled("div")(() => ({
  padding: "16px",
  marginBottom: "16px",
  display: "flex",
  alignItems: "center",
  height: topBarHeight,
  boxShadow: themeShadows[6],
  "& h5": {
    marginLeft: "8px",
    marginTop: 0,
    marginBottom: 0,
    fontWeight: "500",
  },
}));

const NotificationBar = ({ container }) => {
  const [panelOpen, setPanelOpen] = React.useState(false);
  const { deleteNotification, clearNotifications, notifications } =
    useNotification();

  const handleDrawerToggle = () => setPanelOpen(!panelOpen);

  return (
    <Fragment>
      <IconButton onClick={handleDrawerToggle}>
        <Badge color="secondary" badgeContent={notifications?.length}>
          <CustomIcon name="notification" />
        </Badge>
      </IconButton>

      <Drawer
        width="100px"
        container={container}
        variant="temporary"
        anchor="right"
        open={panelOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
      >
        <Box sx={{ width: sideNavWidth }}>
          <Notification>
            <Icon color="primary">notifications</Icon>
            <h5>Notifications</h5>
          </Notification>

          {!!notifications?.length && (
            <Box>
              <Button onClick={clearNotifications}>
                Clear Notifications
              </Button>
            </Box>
          )}
        </Box>
      </Drawer>
    </Fragment>
  );
};

export default NotificationBar;